import { render, staticRenderFns } from "./DFCorrection.vue?vue&type=template&id=a89ea560&scoped=true"
import script from "./DFCorrection.vue?vue&type=script&lang=js"
export * from "./DFCorrection.vue?vue&type=script&lang=js"
import style0 from "./DFCorrection.vue?vue&type=style&index=0&id=a89ea560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89ea560",
  null
  
)

export default component.exports